export const AUTHOR_ARTICLES_PER_PAGE_DESKTOP = 3;
export const AUTHOR_ARTICLES_PER_PAGE_MOBILE = 1;
export const SIMILAR_ARTICLES_PER_PAGE = 4;

export const COMMENTS_PER_PAGE = 3;
export const REPLY_MAX_LENGTH = 300;

export const RECOMMENDED_LAWYERS_PER_PAGE = 3;
export const RECOMMENDED_LAWYERS_MIN_RATING = 3;
export const PROD_AUTO_LAWYER_CATEGORY_ID = 356;

export const BOTTOM_SECTIONS_TRIGGER_HEIGHT_RATIO = 3;
